<div class="d-flex mb-1 clean-horizontal-scroll filter">
  <app-dropdown-filter [filter]="gamesService.sexFilter"
                        (selectionChange)="gamesService.onFilterChange()">
  </app-dropdown-filter>
  <app-dropdown-filter [filter]="gamesService.stateFilter"
                        (selectionChange)="gamesService.onFilterChange()">
  </app-dropdown-filter>
</div>
<div class="col-md-12 p-0">
  <lib-games-list *ngIf="gamesService.events?.length > 0"
                  [live]="true"
                  [sortByLeague]="true"
                  [useRelativeLinks]="true"
                  [openLinksInNewTab]="false"
                  [showStatus]="true"
                  [showReporterStatus]="true"
                  [showAds]="true"
                  [hideShadow]="true"
                  [showDate]="false"
                  [events]="gamesService.events"
                  [user]="user"></lib-games-list>
  <app-games-placeholder *ngIf="gamesService.events?.length === 0 && !gamesService.loading"
    [isFilterActive]="gamesService.isFilterActive()"
    (deactivateFilter)="deactivateFilterClicked()">
  </app-games-placeholder>
  <div class="container mb-5 mt-5" *ngIf="gamesService.loading">
    <mat-spinner strokeWidth="2" color="primary" diameter="54" class="m-auto"></mat-spinner>
  </div>
  <button mat-raised-button class="load-more mt-2"
          *ngIf="gamesService.moreMatchesAvailable && !gamesService.loading"
          (click)="onLoadMore()">
    Weitere Spiele laden
  </button>
</div>
